import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { bump } from '../../ui/app/store';
import { setGame } from '../economy/ui';
import { unlockAchievements } from './achievements';
import './journal.css';
import { JournalPanel } from './JournalPanel';

export { ACHIEVEMENTS, achievementStates, unlockAchievements } from './achievements';
export { zoneJournal } from './journal';

/** Explorer's Journal, achievements and titles (`journal` panel, O). */
export function install(game: Game): void {
  setGame(game);
  registerPanel('journal', JournalPanel);
  let t = 0;
  game.systems.push((g, dt) => {
    t += dt;
    if (t < 2) return;
    t = 0;
    const p = g.progression;
    if (!p) return;
    const got = unlockAchievements(p);
    if (!got.length) return;
    for (const d of got)
      g.hud.toast(
        `<b style="color:var(--gold-100)">Achievement</b> — ${d.name}${d.reward.title ? ` · title “${d.reward.title}”` : ''}`,
        '#eacd95',
      );
    g.store.saveSoon(g.account);
    bump();
  });
}
